import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useRouterQuery } from '~hooks/useRouterQuery';
import { fetcher } from '~lib/api/fetch';

import QueryKeys from '../queryKeys';
import useGetCompanyInfo from './useCompanyInfo';

const url = (PK_NM_HASH: string) => `/api/company/${PK_NM_HASH}/avgServiceYear`;

interface Response {
  allAvgYear: number;
  avgServiceYear: number;
  date: '2019' | '2020' | '2021';
  sectionAvgYear?: number;
}

type MappedResponse = Map<string, Omit<Response, 'date'>>;

function useGetCompanyEmployeeAvgService() {
  const PK_NM_HASH = useRouterQuery('companyId');
  const { data: companyInfo } = useGetCompanyInfo(PK_NM_HASH);

  return useQuery<Response[], AxiosError, MappedResponse>(
    [QueryKeys.companyEmployeeAvgService, PK_NM_HASH],
    () => fetcher(url(PK_NM_HASH)),
    {
      enabled: !!PK_NM_HASH,
      select: (response) => {
        const data = new Map(
          response.map((item) => {
            if (companyInfo?.industryCode === 'ETC') {
              return [
                item.date,
                {
                  avgServiceYear: item.avgServiceYear,
                  allAvgYear: item.allAvgYear,
                },
              ];
            }

            return [item.date, item];
          }),
        );

        return data;
      },
    },
  );
}

export default useGetCompanyEmployeeAvgService;
